import { Link } from 'react-router-dom'
import config from '../../config'
import { useTranslation } from '@/hooks/useTranslation'
import {
	LegalList,
	LegalP,
	LegalPageLayout,
	LegalSection,
	useLegalList,
	useLegalUpdatedDate,
} from '@/components/legal/LegalPageLayout'

const TermsAndConditions = () => {
	const { t } = useTranslation()
	const date = useLegalUpdatedDate()
	const serviceItems = useLegalList('terms.section2Items')

	return (
		<LegalPageLayout
			title={t('terms.termsOfService')}
			lastUpdated={t('legal.lastUpdated', { date })}
		>
			<LegalSection title={t('terms.section1Title')}>
				<LegalP>
					{t('terms.section1Content', { companyName: config.companyName })}
				</LegalP>
				<LegalP>{t('terms.section1Content2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section2Title')}>
				<LegalP>
					{t('terms.section2Content', { appName: config.name })}
				</LegalP>
				<LegalList items={serviceItems} />
				<LegalP>{t('terms.section2Content2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section3Title')}>
				<LegalP>{t('terms.section3Content')}</LegalP>
				<LegalP>{t('terms.section3Content2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section4Title')}>
				<LegalP>
					{t('terms.section4Content', {
						paymentProvider: config.paymentProvider,
					})}
				</LegalP>
				<LegalP>{t('terms.section4Content2')}</LegalP>
				<LegalP>{t('terms.section4Content3')}</LegalP>
				<LegalP>{t('terms.section4Content4')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section5Title')}>
				<LegalP>{t('terms.section5Content')}</LegalP>
				<LegalP>
					{t('terms.section5Content2', { supportEmail: config.supportEmail })}
				</LegalP>
				<LegalP>{t('terms.section5Content3')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section6Title')}>
				<LegalP>{t('terms.section6Content')}</LegalP>
				<LegalP>{t('terms.section6Content2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section7Title')}>
				<LegalP>{t('terms.section7Content')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section8Title')}>
				<LegalP>{t('terms.section8Content')}</LegalP>
				<LegalP>{t('terms.section8Content2')}</LegalP>
				<LegalP>{t('terms.section8Content3')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section9Title')}>
				<LegalP>{t('terms.section9Content')}</LegalP>
				<LegalP>{t('terms.section9Content2')}</LegalP>
				<LegalP>{t('terms.section9Content3')}</LegalP>
				<LegalP>{t('terms.section9Content4')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section10Title')}>
				<LegalP>{t('terms.section10Content')}</LegalP>
				<LegalP>
					{t('terms.section10Content2', { companyName: config.companyName })}
				</LegalP>
				<LegalP>{t('terms.section10Content3')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section11Title')}>
				<LegalP>
					{t('terms.section11Content', { companyName: config.companyName })}
				</LegalP>
				<LegalP>{t('terms.section11Content2')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section12Title')}>
				<LegalP>
					{t('terms.section12Content1')}{' '}
					<Link
						to="/privacy"
						className="text-primary hover:text-primary/90 font-medium"
					>
						{t('terms.privacyPolicy')}
					</Link>
					. {t('terms.section12Content2')}
				</LegalP>
				<LegalP>
					{t('terms.section12Content3', { companyName: config.companyName })}
				</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section13Title')}>
				<LegalP>
					{t('terms.section13Content', { companyName: config.companyName })}
				</LegalP>
				<LegalP>
					{t('terms.section13Content2', { companyName: config.companyName })}
				</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section14Title')}>
				<LegalP>{t('terms.section14Content')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section15Title')}>
				<LegalP>{t('terms.section15Content')}</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section16Title')}>
				<LegalP>
					{t('terms.section16Content', { companyName: config.companyName })}
				</LegalP>
			</LegalSection>

			<LegalSection title={t('terms.section17Title')}>
				<LegalP>{t('terms.contactDescription')}</LegalP>
				<div className="bg-gray-50 rounded-xl p-6 border border-gray-100 mt-4">
					<p className="text-gray-600">{config.companyName}</p>
					<p className="text-gray-600">{config.companyAddress}</p>
					<p className="text-gray-600 mt-2">
						{t('legal.email')}{' '}
						<a
							href={`mailto:${config.supportEmail}`}
							className="text-primary hover:text-primary/90 font-medium"
						>
							{config.supportEmail}
						</a>
					</p>
				</div>
			</LegalSection>
		</LegalPageLayout>
	)
}

export default TermsAndConditions
